import { useState } from 'react';

const useForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setEmail(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Send reset link
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { email, handleChange, handleSubmit, loading };
};

export default useForgotPassword;
